import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import bgimage from '../../../../../images/raw_material/default_rawmaterial.png';
import productimage from '../../../../../images/product/product.png';
import brandimage from '../../../../../images/product/brand.jpg';
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import axios from 'axios';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';

const AddProduct = ({ show, onClose, defaultCategory, onSuccess, refresh }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  
  const [service_sttm, setServiceSTTMValue] = useState(null); // State for Production Start Time 
  const [service_edtm, setServiceEdTMValue] = useState(null); // State for Production End Time
  const [packing_sttm, setPackingSTTMValue] = useState(null); // State for Packing Start Time
  const [packing_edtm, setPackingEdTMValue] = useState(null); // State for Packing End Time
  const [delivery_sttm, setDeliverySTTMValue] = useState(null); // State for Delivery Start Time
  const [delivery_edtm, setDeliveryEdTMValue] = useState(null); // State for Delivery End Time
  const [isVisible, setIsVisible] = useState({ items: false });

  const toggleDiv = (section) => {
    setIsVisible((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const [item_count, setItemCount] = React.useState('');

  const [optionsProduct, setOptionsProduct] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const [optionsItemCategory, setOptionsItemCategory] = useState([]);
  const [groupedSubCategories, setGroupedSubCategories] = useState({});
  const [item_category, setItemCategory] = useState([]);

  useEffect(() => {
    const fetchProductCategories = async () => {
      try {
        const response = await axios.get(`${baseURL}/product-categories/products/active`);
        const categories = response.data.data;
        if (categories && categories.length > 0) {
          const formattedOptions = categories.map(category => ({
            value: category.sno,
            label: category.productcategory_name,
            schedule_start_time: category.schedule_start_time,
            schedule_end_time: category.schedule_end_time
          }));
          setOptionsProduct(formattedOptions);

          // ✅ Auto-select defaultCategory if passed
          if (defaultCategory) {
            const matched = formattedOptions.find(
              (opt) => opt.value === defaultCategory.sno
            );
            if (matched) {
              setSelectedOption(matched);
              // Also set the times
              if (matched.schedule_start_time) {
                const [hour, minute] = matched.schedule_start_time.split(':').map(Number);
                setServiceSTTMValue(new DateObject().set({ hour, minute }));
              }
              if (matched.schedule_end_time) {
                const [hour, minute] = matched.schedule_end_time.split(':').map(Number);
                setServiceEdTMValue(new DateObject().set({ hour, minute }));
              }
            }
          }
        }
      } catch (error) {
        console.error('Error fetching categories', error);
      }
    };

    fetchProductCategories();
  }, [defaultCategory]);

  // const [optionsItemCategory, setOptionsItemCategory] = useState([]);
  const [selectedOptionItemCategory, setSelectedOptionItemCategory] = useState(null);

  useEffect(() => {
    const fetchGroupedCategories = async () => {
      try {
        const response = await axios.get(`${baseURL}/grouped-item-categories`);
        const data = response.data.data;

        // Set category options
        const categoryOptions = data.map((cat) => ({
          value: cat.itemcategory_id,
          label: cat.itemcategory_name,
        }));
        setOptionsItemCategory(categoryOptions);

        // Build subcategory map
        const subcategoryMap = {};
        data.forEach((cat) => {
          subcategoryMap[cat.itemcategory_id] = cat.subcategories.map((sub) => ({
            value: sub.itemsubcategory_id,
            label: sub.itemsubcategory_name,
          }));
        });
        setGroupedSubCategories(subcategoryMap);

      } catch (error) {
        console.error('Error fetching categories with subcategories:', error);
      }
    };

    fetchGroupedCategories();
  }, []);

  const fileHandler = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const RemoveImage = () => {
    setFile(null);
    if (imageInputRef.current) {
      imageInputRef.current.value = '';
    }
  };

  const [itemcat, setitemcat] = useState([{ id: Date.now() }]);

  const handleAddConfig = () => {
    setitemcat([...itemcat, { id: Date.now() }]);
  };

  const handleDeleteConfig = (id) => {
    setitemcat(itemcat.filter(config => config.id !== id));
  };

  const [errors, setErrors] = useState({}); // error 
  const [itemcatErrors, setItemcatErrors] = useState({}); //error

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    const itemFieldErrors = {};

    // --- Main Field Validations ---
    if (!e.target.product_name.value.trim()) {
      newErrors.product_name = "Product Name is required";
    }
    if (!selectedOption) {
      newErrors.product_category_id = "Select Product Category";
    }
    if (!service_sttm) {
      newErrors.production_start_time = "Production Start Time is required";
    }
    if (!service_edtm) {
      newErrors.production_end_time = "Production End Time is required";
    }
    if (!packing_sttm) {
      newErrors.packing_start_time = "Packing Start Time is required";
    }
    if (!packing_edtm) {
      newErrors.packing_end_time = "Packing End Time is required";
    }
    if (!delivery_sttm) {
      newErrors.delivery_start_time = "Delivery Start Time is required";
    }
    if (!delivery_edtm) {
      newErrors.delivery_end_time = "Delivery End Time is required";
    }

    const countVal = parseInt(item_count, 10);
    if (!countVal || isNaN(countVal) || countVal <= 0) {
      itemFieldErrors.count = "Valid item count is required";
    }

    // --- Ensure item_category has countVal rows ---
    // const paddedCategory = [...item_category];
    // for (let i = paddedCategory.length; i < countVal; i++) {
    //   paddedCategory.push({ category: null, count: "1" });
    // }

    // const normalizedCategory = paddedCategory.map(item => ({
    //   ...item,
    //   count: item.count && item.count.toString().trim() !== "" ? item.count.toString() : "1",
    // }));

    // setItemCategory(normalizedCategory); // update UI

    // // --- Validate & Build item_category_list ---
    // const itemCategoryList = normalizedCategory.map((item, index) => {
    //   const categoryId = item.category?.value;
    //   const count = parseInt(item.count, 10);
    //   const subcategoriesRaw = item.subcategories || [];

    //   if (!categoryId) {
    //     itemFieldErrors[`category_${index}`] = "Category is required";
    //   }
    //   if (!count || count <= 0) {
    //     itemFieldErrors[`count_${index}`] = "Valid count is required";
    //   }
    //   if (subcategoriesRaw.length === 0) {
    //     itemFieldErrors[`subcategories_${index}`] = "At least one subcategory is required";
    //   }

    //   const subcategories = subcategoriesRaw.map(sub => ({
    //     itemsubcategory_id: sub.value,
    //     itemsubcategory_name: sub.label,
    //   }));

    //   return {
    //     item_category_id: categoryId,
    //     count: count || 0,
    //     subcategories,
    //   };
    // });

    // --- Image Size Validation ---
    const MAX_SIZE = 51200; // 50KB
    let productImageError = "";
    let brandImageError = "";

    if (file && file.size > MAX_SIZE) {
      productImageError = "Product image must be below 50KB";
    }
    if (brandFile && brandFile.size > MAX_SIZE) {
      brandImageError = "Brand image must be below 50KB";
    }

    // --- Handle Errors ---
    if (
      Object.keys(newErrors).length > 0 ||
      Object.keys(itemFieldErrors).length > 0 ||
      productImageError ||
      brandImageError
    ) {
      setErrors(newErrors);
      setItemcatErrors(itemFieldErrors);
      setProductImageError(productImageError);
      setBrandImageError(brandImageError);
      return;
    }

    // --- Clear Errors ---
    setErrors({});
    setItemcatErrors({});
    setProductImageError("");
    setBrandImageError("");

    // --- Prepare FormData ---
    const formData = new FormData();
    formData.append("branch_id", branch_id);
    formData.append("created_by", user_id);
    formData.append("product_name", e.target.product_name.value);
    formData.append("product_category_id", selectedOption.value);
    formData.append("production_start_time", service_sttm.format("hh:mm A"));
    formData.append("production_end_time", service_edtm.format("hh:mm A"));
    formData.append("packing_start_time", packing_sttm.format("hh:mm A"));
    formData.append("packing_end_time", packing_edtm.format("hh:mm A"));
    formData.append("delivery_start_time", delivery_sttm.format("hh:mm A"));
    formData.append("delivery_end_time", delivery_edtm.format("hh:mm A"));
    if (file) formData.append("product_image", file);
    if (brandFile) formData.append("brand_image", brandFile);
    if (productColor) formData.append("product_color", productColor);

    formData.append("item_count", countVal);
    // formData.append("item_category_list", JSON.stringify(itemCategoryList));
    formData.append("description", e.target.description.value);

    // --- Submit to API ---
    try {
      await axios.post(`${baseURL}/manages-products`, formData);
      // No toast, no alert, just call success handlers
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      console.error("❌ Error creating product:", error);

      if (error.response) {
        const { status, data } = error.response;

        if (status === 422 && data.errors) {
          // Validation errors from backend
          setErrors(data.errors);
        } else if (status === 409 && data.message) {
          // Product already exists error
          setErrors(prevErrors => ({
            ...prevErrors,
            product_name: data.message,
          }));
        } else if (data.message) {
          setErrors(prevErrors => ({
            ...prevErrors,
            general: data.message,
          }));
        } else {
          setErrors(prevErrors => ({
            ...prevErrors,
            general: "Something went wrong. Please try again.",
          }));
        }
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          general: "Network error. Please check your connection.",
        }));
      }
    }
  };

  const handleTextInputChange = (e) => {
    let value = e.target.value;

    if (value) {
      value = value
        .split(' ')
        .map((word) =>
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');  // Rejoin the words into a single string
    }

    // Set the updated value to the input field
    e.target.value = value;
  };

  // Use the same function for both product name and description
  const handleProductNameChange = handleTextInputChange;
  const handleDescriptionChange = handleTextInputChange;

  const handleProductCategoryChange = (selected) => {
    setSelectedOption(selected);

    // Convert "23:30:00" into hour and minute values
    if (selected.schedule_start_time) {
      const [hour, minute] = selected.schedule_start_time.split(':').map(Number);
      const startTime = new DateObject().set({ hour, minute });
      setServiceSTTMValue(startTime);
    }

    if (selected.schedule_end_time) {
      const [hour, minute] = selected.schedule_end_time.split(':').map(Number);
      const endTime = new DateObject().set({ hour, minute });
      setServiceEdTMValue(endTime);
    }
  };

  const [productColor, setProductColor] = React.useState('#000000');
  const removeBrandImage = () => {
    setBrandFile(null);
  };

  const [file, setFile] = useState(null); // Product image
  const [brandFile, setBrandFile] = useState(null); // Brand image
  const [productImageError, setProductImageError] = useState("");
  const [brandImageError, setBrandImageError] = useState("");
  const imageInputRef = useRef(null);
  const brandImageInputRef = useRef(null);
  const handleProductFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 51200) {
        setProductImageError("Product image must be below 50KB");
        setFile(null);
      } else {
        setProductImageError("");
        setFile(selectedFile);
      }
    }
  };

  const handleBrandFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 51200) {
        setBrandImageError("Brand image must be below 50KB");
        setBrandFile(null);
      } else {
        setBrandImageError("");
        setBrandFile(selectedFile);
      }
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isDisabled ? '#e9ecef' : (state.isFocused ? '#ced4da' : '#ced4da'), // lighter border if disabled
      backgroundColor: state.isDisabled ? '#e9ecef' : 'white',  // gray background if disabled
      boxShadow: 'none',
      minHeight: '38px',
      height: '38px',
      cursor: state.isDisabled ? 'not-allowed' : 'default',
      '&:hover': {
        borderColor: state.isDisabled ? '#e9ecef' : '#adb5bd',
      },
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      display: state.isDisabled ? 'none' : 'none',  // keep no arrow regardless, but you can toggle here
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? '#6c757d' : '#6c757d',
      fontSize: '14px',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      fontSize: '14px',
      color: state.isDisabled ? '#6c757d' : '#212529',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  return (
    <Modal show={show} size="lg"  >
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Product</h3>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>

            <div className="row">

              <div className='col-lg-8'>
                <div className='row'>
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Product Category<span className="required">*</span></label>
                    <Select
                      placeholder="Select Product Ctgy"
                      value={selectedOption}
                      onChange={handleProductCategoryChange}
                      options={optionsProduct}
                      className={errors.product_category_id ? 'is-invalid' : ''}
                      styles={customStyles}
                      isDisabled={true}  // <-- disabled here
                    />
                  </div>

                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">
                      Product Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="product_name"
                      className="form-control"
                      placeholder="Enter Product Name"
                      maxLength={25}
                      onChange={(e) => {
                        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // allow letters and space
                        handleProductNameChange({ target: { name: 'product_name', value: onlyLetters } });
                      }}
                    />
                    {errors.product_name && (
                      <span className="text-danger fs-8">{errors.product_name}</span>
                    )}
                  </div>

                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Production Start Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                      <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-clock fs-4'></i>
                      </div>
                      <DatePicker
                        placeholder="Product Start Time"
                        disableDayPicker
                        value={service_sttm}
                        onChange={() => { }} // Prevent manual change
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                        editable={false}
                      />
                    </div>
                    {errors.production_start_time && (
                      <span className="text-danger fs-8">{errors.production_start_time}</span>
                    )}
                  </div>

                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Production End Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                      <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-clock fs-4'></i>
                      </div>
                      <DatePicker
                        placeholder="Product End Time"
                        disableDayPicker
                        value={service_edtm}
                        onChange={() => { }} // Prevent manual change
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                        editable={false}
                      />
                    </div>
                    {errors.production_end_time && (
                      <span className="text-danger fs-8">{errors.production_end_time}</span>
                    )}
                  </div>

                </div>
              </div>

              <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 fs-7 d-block">Product Image</label>
                <span className='fs-8 text-gray-800'>Size: </span>
                <span className='fs-8 text-danger'>15 * 15</span>
                <span className='fs-8 text-gray-800 ms-2'>Format: </span>
                <span className='fs-8 text-danger'>.png, .jpg</span>
                <div className="avatar-upload d-flex align-items-center">
                  <div className="change position-relative px-0">
                    <div className="avatar-preview h-80px w-100px border" style={{ borderRadius: '10px' }}>
                      <img
                        id="saveImageFile"
                        src={file ? URL.createObjectURL(file) : bgimage}
                        alt={file ? file.name : 'Default Avatar'}
                        className="p-1 h-80px w-100px"
                      />
                    </div>
                    <div className="change-btn">
                      <input
                        type="file"
                        id="imageUpload"
                        accept=".png, .jpg, .jpeg"
                        style={{ display: 'none' }}
                        onChange={fileHandler}
                        ref={imageInputRef}
                      />
                      <div className="mt-2 d-flex justify-content-center gap-3">
                        <Button
                          className="btn-xs mb-2"
                          variant="success"
                          onClick={() => imageInputRef.current.click()}
                        >
                          <i className="fa fa-upload color-success fs-4" />
                        </Button>
                        <Button
                          className="btn-xs mb-2"
                          variant="danger"
                          onClick={RemoveImage}
                        >
                          <i className="fa fa-close color-danger fs-4" />
                        </Button>
                      </div>
                    </div>
                    {productImageError && <span className="text-danger fs-8 d-block mt-1">{productImageError}</span>}
                  </div>
                </div>
              </div>

            </div>

            <div className='row'>

              <div className='col-lg-8'>
                <div className='row'>

                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Packing Start Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                      <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-clock fs-4'></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={packing_sttm}
                        onChange={setPackingSTTMValue}
                        // format="hh : mm A"
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                        className={errors.packing_start_time ? 'border border-danger' : ''}
                      />
                    </div>
                    {errors.packing_start_time && (
                      <span className="text-danger fs-8">{errors.packing_start_time}</span>
                    )}
                  </div>

                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Packing End Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                      <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-clock fs-4'></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={packing_edtm}
                        onChange={setPackingEdTMValue}
                        // format="hh : mm A"
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                        className={errors.packing_end_time ? 'border border-danger' : ''}
                      />
                    </div>
                    {errors.packing_end_time && (
                      <span className="text-danger fs-8">{errors.packing_end_time}</span>
                    )}
                  </div>

                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Delivery Start Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                      <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-clock fs-4'></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={delivery_sttm}
                        onChange={setDeliverySTTMValue}
                        // format="hh : mm A"
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                        className={errors.delivery_start_time ? 'border border-danger' : ''}
                      />
                    </div>
                    {errors.delivery_start_time && (
                      <span className="text-danger fs-8">{errors.delivery_start_time}</span>
                    )}
                  </div>

                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Delivery End Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                      <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-clock fs-4'></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={delivery_edtm}
                        onChange={setDeliveryEdTMValue}
                        // format="hh : mm A"
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                        className={errors.delivery_end_time ? 'border border-danger' : ''}
                      />
                    </div>
                    {errors.delivery_end_time && (
                      <span className="text-danger fs-8">{errors.delivery_end_time}</span>
                    )}
                  </div>

                </div>
              </div>

              <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 fs-7 d-block">Brand Image</label>
                <span className='fs-8 text-gray-800'>Size: </span>
                <span className='fs-8 text-danger'>15 * 15</span>
                <span className='fs-8 text-gray-800 ms-2'>Format: </span>
                <span className='fs-8 text-danger'>.png, .jpg</span>
                <div className="avatar-upload d-flex align-items-center">
                  <div className="change position-relative px-0">
                    <div className="avatar-preview h-80px w-100px border" style={{ borderRadius: '10px' }}>
                      <img
                        id="brandImagePreview"
                        src={brandFile ? URL.createObjectURL(brandFile) : bgimage}
                        alt={brandFile ? brandFile.name : 'Default Brand Image'}
                        className="p-1 h-80px w-100px"
                      />
                    </div>
                    <div className="change-btn">
                      <input
                        type="file"
                        id="brandImageUpload"
                        accept=".png, .jpg, .jpeg"
                        style={{ display: 'none' }}
                        onChange={handleBrandFileChange}
                        ref={brandImageInputRef}
                      />
                      <div className="mt-2 d-flex justify-content-center gap-3">
                        <Button
                          className="btn-xs mb-2"
                          variant="success"
                          onClick={() => brandImageInputRef.current.click()}
                        >
                          <span className="">
                            <i className="fa fa-upload color-success fs-4" />
                          </span>
                        </Button>
                        <Button
                          className="btn-xs mb-2"
                          variant="danger"
                          onClick={removeBrandImage}
                        >
                          <span className="">
                            <i className="fa fa-close color-danger fs-4" />
                          </span>
                        </Button>
                      </div>
                    </div>
                    {brandImageError && <span className="text-danger fs-8 d-block mt-1">{brandImageError}</span>}
                  </div>
                </div>
              </div>

            </div>

            <div className='row'>
              <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 fs-7">Product Color <span className="required">*</span></label>
                <input
                  type="color"
                  className="form-control"
                  placeholder="Choose Product Color"
                  value={productColor}
                  onChange={(e) => setProductColor(e.target.value)}
                />
              </div>

              <div className="col-lg-8">
                <label className="text-black font-w500 fs-7">Description</label>
                <textarea
                  rows={1}
                  className="form-control h-auto"
                  name="description"
                  placeholder="Description"
                  maxLength={100}
                  onChange={handleDescriptionChange}
                />
              </div>

            </div>

            <div className='row'>
              <div className='col-lg-4 mb-4 position-relative'>
                <label className="text-black font-w500 fs-7">
                  Number Of Item Category<span className="required">*</span>
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="number"
                    // className={`form-control pe-5 ${itemcatErrors?.count ? 'border-danger' : ''}`}
                    className="form-control"
                    placeholder="Enter No Of Items Category"
                    value={item_count}
                    readOnly
                  />
                  <button
                    type="button"
                    className="btn btn-success position-absolute top-50 translate-middle-y"
                    style={{
                      right: '8px',
                      padding: '4px 10px',
                      zIndex: 10,
                    }}
                    onClick={() => {
                      const newCount = parseInt(item_count || 0, 10) + 1;
                      setItemCount(newCount);

                      const updated = Array.from({ length: newCount }, (_, index) => ({
                        category: item_category[index]?.category || null,
                        count: item_category[index]?.count || '',
                        subcategories: item_category[index]?.subcategories || [],
                      }));
                      setItemCategory(updated);
                    }}
                  >
                    <i className="fa fa-plus"></i>
                  </button>
                </div>
                {itemcatErrors?.count && (
                  <span className="text-danger fs-8">{itemcatErrors.count}</span>
                )}
              </div>
            </div>

            {/* {item_count > 0 && item_category.length > 0 && (
              <div className="row">
                <div className="col-lg-12">
                  <label className="text-black font-w500 fs-7">
                    Item Categories & Counts<span className="required">*</span>
                  </label>

                  <div
                    style={{
                      maxHeight: '250px',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      paddingRight: '10px',
                      border: '1px solid #dee2e6',
                      borderRadius: '5px',
                      padding: '10px',
                    }}
                  >
                    {item_category.map((item, index) => {
                      const availableCategoryOptions = optionsItemCategory.filter(
                        (option) =>
                          !item_category.some(
                            (selectedItem, selectedIndex) =>
                              selectedIndex !== index &&
                              selectedItem.category?.value === option.value
                          )
                      );

                      return (
                        <div className="row mb-3 align-items-end" key={index}>

                          <div className="col-lg-4">
                            <label className="text-black font-w500 fs-7">
                              Item Category #{index + 1} <span className="required">*</span>
                            </label>
                            <Select
                              placeholder={`Select Item Category #${index + 1}`}
                              value={item.category}
                              onChange={(selected) => {
                                const updated = [...item_category];
                                updated[index] = {
                                  ...updated[index],
                                  category: selected,
                                  subcategories: [],
                                };
                                setItemCategory(updated);
                              }}
                              options={availableCategoryOptions}
                              menuPlacement="top"
                              menuPortalTarget={document.body}
                              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                            {itemcatErrors?.[`category_${index}`] && (
                              <span className="text-danger fs-8">
                                {itemcatErrors[`category_${index}`]}
                              </span>
                            )}
                          </div>

                          <div className="col-lg-6">
                            <label className="text-black font-w500 fs-7">
                              Item Subcategories #{index + 1} <span className="required">*</span>
                            </label>
                            <Select
                              isMulti
                              placeholder="Select Subcategories"
                              value={item.subcategories || []}
                              onChange={(selectedOptions) => {
                                const updated = [...item_category];
                                updated[index] = {
                                  ...updated[index],
                                  subcategories: selectedOptions,
                                };
                                setItemCategory(updated);
                              }}
                              options={
                                item.category?.value
                                  ? groupedSubCategories[item.category.value] || []
                                  : []
                              }
                              menuPlacement="top"
                              menuPortalTarget={document.body}
                              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                            {itemcatErrors?.[`subcategories_${index}`] && (
                              <span className="text-danger fs-8">
                                {itemcatErrors[`subcategories_${index}`]}
                              </span>
                            )}
                          </div>



                          <div className="col-lg-2 d-none">
                            <label className="text-black font-w500 fs-7">
                              Count <span className="required">*</span>
                            </label>
                            <input
                              type="number"
                              className={`form-control ${itemcatErrors?.[`count_${index}`] ? 'border-danger' : ''}`}
                              min={1}
                              value={item.count}
                              onChange={(e) => {
                                const updated = [...item_category];
                                updated[index] = {
                                  ...updated[index],
                                  count: e.target.value,
                                };
                                setItemCategory(updated);
                              }}
                            />
                            {itemcatErrors?.[`count_${index}`] && (
                              <span className="text-danger fs-8">
                                {itemcatErrors[`count_${index}`]}
                              </span>
                            )}
                          </div>

                          <div className="col-lg-2 text-end">
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => {
                                const updated = [...item_category];
                                updated.splice(index, 1);
                                setItemCategory(updated);
                                setItemCount(updated.length);
                              }}
                              disabled={item_category.length <= 1}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )} */}

            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
              <button type="submit" className="btn btn-sm btn-primary">Create Product <i className="fas fa-angle-double-right ms-2"></i></button>
            </div>

          </form>
        </div>

      </div>

    </Modal >
  );






};

export default AddProduct;
